/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeNewsStatusRequestDto } from '../models';
// @ts-ignore
import type { CreateNewsRequestDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { NewsCategoryDto } from '../models';
// @ts-ignore
import type { NewsDetailDto } from '../models';
// @ts-ignore
import type { NewsImageUploadRequestDto } from '../models';
// @ts-ignore
import type { NewsImageUploadResponseDto } from '../models';
// @ts-ignore
import type { NewsListResponseDto } from '../models';
// @ts-ignore
import type { NewsMediaDto } from '../models';
// @ts-ignore
import type { NewsStatusDto } from '../models';
// @ts-ignore
import type { NewsVideoPlaybackStatusResponseDto } from '../models';
// @ts-ignore
import type { NewsVideoUploadRequestDto } from '../models';
// @ts-ignore
import type { NewsVideoUploadResponseDto } from '../models';
// @ts-ignore
import type { UpdateNewsRequestDto } from '../models';
/**
 * NewsManagementApi - axios parameter creator
 * @export
 */
export const NewsManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Valid transitions DRAFT↔PUBLISHED, PUBLISHED→ARCHIVED. Requires news.management.write.
         * @summary Change news status (publish / archive / back to draft)
         * @param {number} newsId 
         * @param {ChangeNewsStatusRequestDto} changeNewsStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeNewsStatus: async (newsId: number, changeNewsStatusRequestDto: ChangeNewsStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('changeNewsStatus', 'newsId', newsId)
            // verify required parameter 'changeNewsStatusRequestDto' is not null or undefined
            assertParamExists('changeNewsStatus', 'changeNewsStatusRequestDto', changeNewsStatusRequestDto)
            const localVarPath = `/api/v1/admin/news/{newsId}/status`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeNewsStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks news_media row as UPLOADED. Requires news.management.write.
         * @summary Confirm a media upload is complete
         * @param {number} newsId 
         * @param {number} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmNewsMediaUpload: async (newsId: number, mediaId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('confirmNewsMediaUpload', 'newsId', newsId)
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('confirmNewsMediaUpload', 'mediaId', mediaId)
            const localVarPath = `/api/v1/admin/news/{newsId}/media/{mediaId}/confirm`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)))
                .replace(`{${"mediaId"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires news.management.write. Content is sanitized server-side.
         * @summary Create a news item (as DRAFT)
         * @param {CreateNewsRequestDto} createNewsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNews: async (createNewsRequestDto: CreateNewsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNewsRequestDto' is not null or undefined
            assertParamExists('createNews', 'createNewsRequestDto', createNewsRequestDto)
            const localVarPath = `/api/v1/admin/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNewsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets status=ARCHIVED and deletedAt. Requires news.management.write.
         * @summary Soft-delete (archive) a news item
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNews: async (newsId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('deleteNews', 'newsId', newsId)
            const localVarPath = `/api/v1/admin/news/{newsId}`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all news items including DRAFT and ARCHIVED. Requires news.management.read.
         * @summary List news for management panel
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NewsCategoryDto} [category] 
         * @param {NewsStatusDto} [status] 
         * @param {string} [search] Filter by title (partial, case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminNews: async (page?: number, pageSize?: number, category?: NewsCategoryDto, status?: NewsStatusDto, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns any status (DRAFT/PUBLISHED/ARCHIVED). Requires news.management.read.
         * @summary Get a news item for management
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminNewsById: async (newsId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('getAdminNewsById', 'newsId', newsId)
            const localVarPath = `/api/v1/admin/news/{newsId}`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns whether the Bunny Stream video has finished transcoding and is playable. FE polls this after upload to avoid rendering a not-yet-ready player. Requires news.management.write. 
         * @summary Get video playback readiness (Bunny Stream transcoding state)
         * @param {number} newsId 
         * @param {number} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsVideoPlaybackStatus: async (newsId: number, mediaId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('getNewsVideoPlaybackStatus', 'newsId', newsId)
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('getNewsVideoPlaybackStatus', 'mediaId', mediaId)
            const localVarPath = `/api/v1/admin/news/{newsId}/media/{mediaId}/playback-status`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)))
                .replace(`{${"mediaId"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a PENDING news_media row, returns a short-lived presigned PUT URL. FE uploads the image bytes directly to S3 then calls confirm endpoint. Requires news.management.write. 
         * @summary Request a presigned URL to upload a news image directly to S3
         * @param {number} newsId 
         * @param {NewsImageUploadRequestDto} newsImageUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewsImageUploadUrl: async (newsId: number, newsImageUploadRequestDto: NewsImageUploadRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('requestNewsImageUploadUrl', 'newsId', newsId)
            // verify required parameter 'newsImageUploadRequestDto' is not null or undefined
            assertParamExists('requestNewsImageUploadUrl', 'newsImageUploadRequestDto', newsImageUploadRequestDto)
            const localVarPath = `/api/v1/admin/news/{newsId}/media/image-upload-url`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newsImageUploadRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates the video on Bunny Stream and returns short-lived signed credentials for a direct TUS upload from the FE. The Bunny API key never leaves the backend. Requires news.management.write. 
         * @summary Request Bunny Stream upload credentials for a news video
         * @param {number} newsId 
         * @param {NewsVideoUploadRequestDto} newsVideoUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewsVideoUploadCredentials: async (newsId: number, newsVideoUploadRequestDto: NewsVideoUploadRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('requestNewsVideoUploadCredentials', 'newsId', newsId)
            // verify required parameter 'newsVideoUploadRequestDto' is not null or undefined
            assertParamExists('requestNewsVideoUploadCredentials', 'newsVideoUploadRequestDto', newsVideoUploadRequestDto)
            const localVarPath = `/api/v1/admin/news/{newsId}/media/video-upload-credentials`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newsVideoUploadRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates title, category and/or content. Requires news.management.write.
         * @summary Update a news item
         * @param {number} newsId 
         * @param {UpdateNewsRequestDto} updateNewsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNews: async (newsId: number, updateNewsRequestDto: UpdateNewsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('updateNews', 'newsId', newsId)
            // verify required parameter 'updateNewsRequestDto' is not null or undefined
            assertParamExists('updateNews', 'updateNewsRequestDto', updateNewsRequestDto)
            const localVarPath = `/api/v1/admin/news/{newsId}`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNewsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsManagementApi - functional programming interface
 * @export
 */
export const NewsManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Valid transitions DRAFT↔PUBLISHED, PUBLISHED→ARCHIVED. Requires news.management.write.
         * @summary Change news status (publish / archive / back to draft)
         * @param {number} newsId 
         * @param {ChangeNewsStatusRequestDto} changeNewsStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeNewsStatus(newsId: number, changeNewsStatusRequestDto: ChangeNewsStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeNewsStatus(newsId, changeNewsStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.changeNewsStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks news_media row as UPLOADED. Requires news.management.write.
         * @summary Confirm a media upload is complete
         * @param {number} newsId 
         * @param {number} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmNewsMediaUpload(newsId: number, mediaId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsMediaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmNewsMediaUpload(newsId, mediaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.confirmNewsMediaUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires news.management.write. Content is sanitized server-side.
         * @summary Create a news item (as DRAFT)
         * @param {CreateNewsRequestDto} createNewsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNews(createNewsRequestDto: CreateNewsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNews(createNewsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.createNews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets status=ARCHIVED and deletedAt. Requires news.management.write.
         * @summary Soft-delete (archive) a news item
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNews(newsId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNews(newsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.deleteNews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all news items including DRAFT and ARCHIVED. Requires news.management.read.
         * @summary List news for management panel
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NewsCategoryDto} [category] 
         * @param {NewsStatusDto} [status] 
         * @param {string} [search] Filter by title (partial, case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminNews(page?: number, pageSize?: number, category?: NewsCategoryDto, status?: NewsStatusDto, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminNews(page, pageSize, category, status, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.getAdminNews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns any status (DRAFT/PUBLISHED/ARCHIVED). Requires news.management.read.
         * @summary Get a news item for management
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminNewsById(newsId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminNewsById(newsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.getAdminNewsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns whether the Bunny Stream video has finished transcoding and is playable. FE polls this after upload to avoid rendering a not-yet-ready player. Requires news.management.write. 
         * @summary Get video playback readiness (Bunny Stream transcoding state)
         * @param {number} newsId 
         * @param {number} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsVideoPlaybackStatus(newsId: number, mediaId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsVideoPlaybackStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsVideoPlaybackStatus(newsId, mediaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.getNewsVideoPlaybackStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a PENDING news_media row, returns a short-lived presigned PUT URL. FE uploads the image bytes directly to S3 then calls confirm endpoint. Requires news.management.write. 
         * @summary Request a presigned URL to upload a news image directly to S3
         * @param {number} newsId 
         * @param {NewsImageUploadRequestDto} newsImageUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestNewsImageUploadUrl(newsId: number, newsImageUploadRequestDto: NewsImageUploadRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsImageUploadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestNewsImageUploadUrl(newsId, newsImageUploadRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.requestNewsImageUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates the video on Bunny Stream and returns short-lived signed credentials for a direct TUS upload from the FE. The Bunny API key never leaves the backend. Requires news.management.write. 
         * @summary Request Bunny Stream upload credentials for a news video
         * @param {number} newsId 
         * @param {NewsVideoUploadRequestDto} newsVideoUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestNewsVideoUploadCredentials(newsId: number, newsVideoUploadRequestDto: NewsVideoUploadRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsVideoUploadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestNewsVideoUploadCredentials(newsId, newsVideoUploadRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.requestNewsVideoUploadCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates title, category and/or content. Requires news.management.write.
         * @summary Update a news item
         * @param {number} newsId 
         * @param {UpdateNewsRequestDto} updateNewsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNews(newsId: number, updateNewsRequestDto: UpdateNewsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNews(newsId, updateNewsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsManagementApi.updateNews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NewsManagementApi - factory interface
 * @export
 */
export const NewsManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsManagementApiFp(configuration)
    return {
        /**
         * Valid transitions DRAFT↔PUBLISHED, PUBLISHED→ARCHIVED. Requires news.management.write.
         * @summary Change news status (publish / archive / back to draft)
         * @param {number} newsId 
         * @param {ChangeNewsStatusRequestDto} changeNewsStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeNewsStatus(newsId: number, changeNewsStatusRequestDto: ChangeNewsStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto> {
            return localVarFp.changeNewsStatus(newsId, changeNewsStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks news_media row as UPLOADED. Requires news.management.write.
         * @summary Confirm a media upload is complete
         * @param {number} newsId 
         * @param {number} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmNewsMediaUpload(newsId: number, mediaId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsMediaDto> {
            return localVarFp.confirmNewsMediaUpload(newsId, mediaId, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires news.management.write. Content is sanitized server-side.
         * @summary Create a news item (as DRAFT)
         * @param {CreateNewsRequestDto} createNewsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNews(createNewsRequestDto: CreateNewsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto> {
            return localVarFp.createNews(createNewsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets status=ARCHIVED and deletedAt. Requires news.management.write.
         * @summary Soft-delete (archive) a news item
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNews(newsId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNews(newsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all news items including DRAFT and ARCHIVED. Requires news.management.read.
         * @summary List news for management panel
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NewsCategoryDto} [category] 
         * @param {NewsStatusDto} [status] 
         * @param {string} [search] Filter by title (partial, case-insensitive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminNews(page?: number, pageSize?: number, category?: NewsCategoryDto, status?: NewsStatusDto, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsListResponseDto> {
            return localVarFp.getAdminNews(page, pageSize, category, status, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns any status (DRAFT/PUBLISHED/ARCHIVED). Requires news.management.read.
         * @summary Get a news item for management
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminNewsById(newsId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto> {
            return localVarFp.getAdminNewsById(newsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns whether the Bunny Stream video has finished transcoding and is playable. FE polls this after upload to avoid rendering a not-yet-ready player. Requires news.management.write. 
         * @summary Get video playback readiness (Bunny Stream transcoding state)
         * @param {number} newsId 
         * @param {number} mediaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsVideoPlaybackStatus(newsId: number, mediaId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsVideoPlaybackStatusResponseDto> {
            return localVarFp.getNewsVideoPlaybackStatus(newsId, mediaId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a PENDING news_media row, returns a short-lived presigned PUT URL. FE uploads the image bytes directly to S3 then calls confirm endpoint. Requires news.management.write. 
         * @summary Request a presigned URL to upload a news image directly to S3
         * @param {number} newsId 
         * @param {NewsImageUploadRequestDto} newsImageUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewsImageUploadUrl(newsId: number, newsImageUploadRequestDto: NewsImageUploadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsImageUploadResponseDto> {
            return localVarFp.requestNewsImageUploadUrl(newsId, newsImageUploadRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates the video on Bunny Stream and returns short-lived signed credentials for a direct TUS upload from the FE. The Bunny API key never leaves the backend. Requires news.management.write. 
         * @summary Request Bunny Stream upload credentials for a news video
         * @param {number} newsId 
         * @param {NewsVideoUploadRequestDto} newsVideoUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewsVideoUploadCredentials(newsId: number, newsVideoUploadRequestDto: NewsVideoUploadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsVideoUploadResponseDto> {
            return localVarFp.requestNewsVideoUploadCredentials(newsId, newsVideoUploadRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates title, category and/or content. Requires news.management.write.
         * @summary Update a news item
         * @param {number} newsId 
         * @param {UpdateNewsRequestDto} updateNewsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNews(newsId: number, updateNewsRequestDto: UpdateNewsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto> {
            return localVarFp.updateNews(newsId, updateNewsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsManagementApi - interface
 * @export
 * @interface NewsManagementApi
 */
export interface NewsManagementApiInterface {
    /**
     * Valid transitions DRAFT↔PUBLISHED, PUBLISHED→ARCHIVED. Requires news.management.write.
     * @summary Change news status (publish / archive / back to draft)
     * @param {number} newsId 
     * @param {ChangeNewsStatusRequestDto} changeNewsStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    changeNewsStatus(newsId: number, changeNewsStatusRequestDto: ChangeNewsStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto>;

    /**
     * Marks news_media row as UPLOADED. Requires news.management.write.
     * @summary Confirm a media upload is complete
     * @param {number} newsId 
     * @param {number} mediaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    confirmNewsMediaUpload(newsId: number, mediaId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsMediaDto>;

    /**
     * Requires news.management.write. Content is sanitized server-side.
     * @summary Create a news item (as DRAFT)
     * @param {CreateNewsRequestDto} createNewsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    createNews(createNewsRequestDto: CreateNewsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto>;

    /**
     * Sets status=ARCHIVED and deletedAt. Requires news.management.write.
     * @summary Soft-delete (archive) a news item
     * @param {number} newsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    deleteNews(newsId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns all news items including DRAFT and ARCHIVED. Requires news.management.read.
     * @summary List news for management panel
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {NewsCategoryDto} [category] 
     * @param {NewsStatusDto} [status] 
     * @param {string} [search] Filter by title (partial, case-insensitive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    getAdminNews(page?: number, pageSize?: number, category?: NewsCategoryDto, status?: NewsStatusDto, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsListResponseDto>;

    /**
     * Returns any status (DRAFT/PUBLISHED/ARCHIVED). Requires news.management.read.
     * @summary Get a news item for management
     * @param {number} newsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    getAdminNewsById(newsId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto>;

    /**
     * Returns whether the Bunny Stream video has finished transcoding and is playable. FE polls this after upload to avoid rendering a not-yet-ready player. Requires news.management.write. 
     * @summary Get video playback readiness (Bunny Stream transcoding state)
     * @param {number} newsId 
     * @param {number} mediaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    getNewsVideoPlaybackStatus(newsId: number, mediaId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsVideoPlaybackStatusResponseDto>;

    /**
     * Creates a PENDING news_media row, returns a short-lived presigned PUT URL. FE uploads the image bytes directly to S3 then calls confirm endpoint. Requires news.management.write. 
     * @summary Request a presigned URL to upload a news image directly to S3
     * @param {number} newsId 
     * @param {NewsImageUploadRequestDto} newsImageUploadRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    requestNewsImageUploadUrl(newsId: number, newsImageUploadRequestDto: NewsImageUploadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsImageUploadResponseDto>;

    /**
     * Creates the video on Bunny Stream and returns short-lived signed credentials for a direct TUS upload from the FE. The Bunny API key never leaves the backend. Requires news.management.write. 
     * @summary Request Bunny Stream upload credentials for a news video
     * @param {number} newsId 
     * @param {NewsVideoUploadRequestDto} newsVideoUploadRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    requestNewsVideoUploadCredentials(newsId: number, newsVideoUploadRequestDto: NewsVideoUploadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsVideoUploadResponseDto>;

    /**
     * Updates title, category and/or content. Requires news.management.write.
     * @summary Update a news item
     * @param {number} newsId 
     * @param {UpdateNewsRequestDto} updateNewsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApiInterface
     */
    updateNews(newsId: number, updateNewsRequestDto: UpdateNewsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto>;

}

/**
 * NewsManagementApi - object-oriented interface
 * @export
 * @class NewsManagementApi
 * @extends {BaseAPI}
 */
export class NewsManagementApi extends BaseAPI implements NewsManagementApiInterface {
    /**
     * Valid transitions DRAFT↔PUBLISHED, PUBLISHED→ARCHIVED. Requires news.management.write.
     * @summary Change news status (publish / archive / back to draft)
     * @param {number} newsId 
     * @param {ChangeNewsStatusRequestDto} changeNewsStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public changeNewsStatus(newsId: number, changeNewsStatusRequestDto: ChangeNewsStatusRequestDto, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).changeNewsStatus(newsId, changeNewsStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks news_media row as UPLOADED. Requires news.management.write.
     * @summary Confirm a media upload is complete
     * @param {number} newsId 
     * @param {number} mediaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public confirmNewsMediaUpload(newsId: number, mediaId: number, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).confirmNewsMediaUpload(newsId, mediaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires news.management.write. Content is sanitized server-side.
     * @summary Create a news item (as DRAFT)
     * @param {CreateNewsRequestDto} createNewsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public createNews(createNewsRequestDto: CreateNewsRequestDto, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).createNews(createNewsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets status=ARCHIVED and deletedAt. Requires news.management.write.
     * @summary Soft-delete (archive) a news item
     * @param {number} newsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public deleteNews(newsId: number, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).deleteNews(newsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all news items including DRAFT and ARCHIVED. Requires news.management.read.
     * @summary List news for management panel
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {NewsCategoryDto} [category] 
     * @param {NewsStatusDto} [status] 
     * @param {string} [search] Filter by title (partial, case-insensitive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public getAdminNews(page?: number, pageSize?: number, category?: NewsCategoryDto, status?: NewsStatusDto, search?: string, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).getAdminNews(page, pageSize, category, status, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns any status (DRAFT/PUBLISHED/ARCHIVED). Requires news.management.read.
     * @summary Get a news item for management
     * @param {number} newsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public getAdminNewsById(newsId: number, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).getAdminNewsById(newsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns whether the Bunny Stream video has finished transcoding and is playable. FE polls this after upload to avoid rendering a not-yet-ready player. Requires news.management.write. 
     * @summary Get video playback readiness (Bunny Stream transcoding state)
     * @param {number} newsId 
     * @param {number} mediaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public getNewsVideoPlaybackStatus(newsId: number, mediaId: number, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).getNewsVideoPlaybackStatus(newsId, mediaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a PENDING news_media row, returns a short-lived presigned PUT URL. FE uploads the image bytes directly to S3 then calls confirm endpoint. Requires news.management.write. 
     * @summary Request a presigned URL to upload a news image directly to S3
     * @param {number} newsId 
     * @param {NewsImageUploadRequestDto} newsImageUploadRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public requestNewsImageUploadUrl(newsId: number, newsImageUploadRequestDto: NewsImageUploadRequestDto, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).requestNewsImageUploadUrl(newsId, newsImageUploadRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates the video on Bunny Stream and returns short-lived signed credentials for a direct TUS upload from the FE. The Bunny API key never leaves the backend. Requires news.management.write. 
     * @summary Request Bunny Stream upload credentials for a news video
     * @param {number} newsId 
     * @param {NewsVideoUploadRequestDto} newsVideoUploadRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public requestNewsVideoUploadCredentials(newsId: number, newsVideoUploadRequestDto: NewsVideoUploadRequestDto, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).requestNewsVideoUploadCredentials(newsId, newsVideoUploadRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates title, category and/or content. Requires news.management.write.
     * @summary Update a news item
     * @param {number} newsId 
     * @param {UpdateNewsRequestDto} updateNewsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsManagementApi
     */
    public updateNews(newsId: number, updateNewsRequestDto: UpdateNewsRequestDto, options?: RawAxiosRequestConfig) {
        return NewsManagementApiFp(this.configuration).updateNews(newsId, updateNewsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

